function click_outside_menus()
{
    $(document).click(function(event)
    {
        // Hide main dropdown menu on system widgets
        if( !$(event.target).closest('.rec-site .rec-site-list').length
            && !$(event.target).closest('.rec-site .menu').length )
        {
            $('.rec-site .rec-site-list').each(function()
            {
                if( $(this).is(':visible') )
                {
                    $(this).hide();
                    $(this).parent().find('.rec-site-tab').hide();
                }
            });
        }

        // Hide secondary dropdown menu on head-to-head system widget
        if( !$(event.target).closest('.head_to_head_candidates .menu').length
            && !$(event.target).closest('.head_to_head_race_dropdown').length )
        {
            $('.head_to_head_race_dropdown').each(function()
            {
                if( $(this).is(':visible') ) {
                    $(this).hide();
                }
            });
        }

        // Hide quick links / advanced filter
        if( !$(event.target).closest('.polls_header_dropdown').length &&
            $(event.target).attr('src') != '/asset/img/grey-bg-chev.png' )
        {

            var $ql_c = $('.polls_header_dropdown .quick_links_content');
            var $f_c = $('.polls_header_dropdown .filter_content');

            $('.polls_header_dropdown .open .quick_links_title').removeClass('active');
            $('.polls_header_dropdown .open .filter_title').removeClass('active');
            $('.polls_header_dropdown .open .arrow').html('<img src="/asset/img/grey-bg-chev.png" alt="Arrow" />');

            if( $ql_c.is(':visible') ) {
                $ql_c.slideToggle();
            } else if( $f_c.is(':visible') ) {
                $f_c.slideToggle();
            }
        }
        if( !$(event.target).closest('.polls_header_2_dropdown').length &&
            $(event.target).attr('src') != '/asset/img/grey-bg-chev.png' )
        {

            var $ql_c = $('.polls_header_2_dropdown .quick_links_content');
            var $f_c = $('.polls_header_2_dropdown .filter_content');

            $('.polls_header_2_dropdown .open .quick_links_title').removeClass('active');
            $('.polls_header_2_dropdown .open .filter_title').removeClass('active');
            $('.polls_header_2_dropdown .open .arrow').html('<img src="/asset/img/grey-bg-chev.png" alt="Arrow" />');

            if( $ql_c.is(':visible') ) {
                $ql_c.slideToggle();
            } else if( $f_c.is(':visible') ) {
                $f_c.slideToggle();
            }
        }

        // verticals menu masthead inner pages
        if( !$(event.target).closest('.verticals-menu').length &&
            !$(event.target).closest('.verticals-site-list').length )
        {
            if( $('.verticals-tab').is(':visible') ) {
                $('.verticals-tab').hide();
                $('.verticals-site-list').hide();
            }
        }

        // social bar Menu
        if( !$(event.target).closest('.jqDrawer').length &&
            !$(event.target).closest('.toolset_drawer').length &&
            !$(event.target).closest('.email_icon').length )
        {
            if( $('.toolset_drawer').is(':visible') ) {
                $('.toolset_drawer').hide(200);
            }
        }

        // homepage date dropdown
        if( !$(event.target).closest('.date-menu').length )

        {
            if( $('.date-menu .menu').is(':visible') ) {
                $('.date-menu .menu').hide();
                $('.date-menu .menu-marker').hide();
            }
        }

    });
}

function sitesMenu(){
    $('.verticals-menu').click(function(){

        //if( $( '.more-nav' ).is( ' :visible' ) ){
        //  $('.more-nav').hide();
        //}

        $('.verticals-tab').toggle();
        $('.verticals-site-list').toggle();
    });
}

//more link drop menu - contains all sections of website
function sectionsMenu(){

    if( $(window).width() > 420 ) {

        $(".site-nav-more").on({
            mouseenter: function (e) {
                //HIDES OTHER DROPDOWNS
                if ($('.verticals-menu').is(' :visible')) {
                    $('.verticals-tab').hide();
                    $('.verticals-site-list').hide();
                }

                $(this).find('.sections-tab').show();
                $(this).find('.primary').show();
            }, mouseleave: function (e) {
                $(this).find('.sections-tab').hide();
                $(this).find('.primary').hide();
            }
        });
    }

    /*, click: function(e) {

      //HIDES OTHER DROPDOWNS
      if( $( '.verticals-menu' ).is( ' :visible' ) ){
        $('.verticals-tab').hide();
        $('.verticals-site-list').hide();
      }

      $(this).find('.sections-tab').toggle();
      $(this).find('.primary').toggle();
    }--
    });  */


    $('li.site-nav-more .jQ-section-menu').click(function(e){
        //alert(e.target+'-'+this);
        e.preventDefault();
        if(e.target != this) return; // only continue if the target itself has been clicked, this is so child submenu clicks will work
        //alert('got here');
        //HIDES OTHER DROPDOWNS
        if( $( '.verticals-menu' ).is( ' :visible' ) ){
            $('.verticals-tab').hide();
            $('.verticals-site-list').hide();
        }

        $(this).parent().find('.sections-tab').toggle();
        $(this).parent().find('.primary').toggle();
    });



    /*
  $(".site-nav-more").hover(
      function () {
      //HIDES OTHER DROPDOWNS
      if( $( '.verticals-menu' ).is( ' :visible' ) ){
        $('.verticals-tab').hide();
        $('.verticals-site-list').hide();
      }

      $(this).find('.sections-tab').show();
      $(this).find('.primary').show();
      },
      function () {
       $(this).find('.sections-tab').hide();
       $(this).find('.primary').hide();
      }
  ); */
}

//inner sections menu handler - opens sub-sections for modules like Polls, Elections 2016, Etc...
function sectionsInnerMenu(){
    $('.site-nav-more ul.primary li a').on('click', function(){
        //alert('test');
        if( $(this).not('.static') ){
            $(this).parent().find('.inner').toggle();
        }
        /*if( $(this).is('.static') ){
      $('.more-nav').toggle();
      var url = $(this).attr('href');
      location.href  = url;
    }*/
    });
}

//open sitesMenu hover handler - changes color of pointer triangle at top of menu to match hovered site
function sitesMenuHover(){
    $('.verticals-site-list ul li a').on('mouseenter', function(){
        if($(this).is(':hover')){
            var bg = $(this).css('background-color');
            var parent = $(this).parent().parent().parent().parent();

            $('.verticals-tab').css( { "border-bottom" : "10px solid " + bg } );
        }
    });

    $('.verticals-site-list ul li a').on('mouseleave', function(){
        if($(this).not(':hover')){
            $('.verticals-tab').css( { "border-bottom" : "10px solid #EBEBEB" } );
        }
    });
}

//open sitesMenu hover handler - changes color of pointer triangle at top of menu to match hovered site
function recommendedSitesMenuHover(){
    $('.rec-site-list ul li a').on('mouseenter', function(){
        if($(this).is(':hover')){
            var bg = $(this).css('background-color');
            var parent = $(this).parent().parent().parent().parent();

            $('.rec-site-tab').css( { "border-bottom" : "10px solid " + bg } );
        }
    });

    $('.verticals-site-list ul li a').on('mouseleave', function(){
        if($(this).not(':hover')){
            $('.verticals-tab').css( { "border-bottom" : "10px solid #EBEBEB" } );
        }
    });
}

function init_menus()
{
    click_outside_menus();
    sitesMenu();
    sitesMenuHover();
    sectionsMenu();
    sectionsInnerMenu();
    recommendedSitesMenuHover();
}

export default init_menus;